import { carrierGroupFromCode } from './carrierIcons';

export function getTrackingLink(carrierCode, trackingNumber) {
  if (!carrierCode || !trackingNumber) return null;
  const group = carrierGroupFromCode(carrierCode);
  switch (group) {
    case 'ups':
      return `https://wwwapps.ups.com/WebTracking/processRequest?HTMLVersion=5.0&Requester=NES&AgreeToTermsAndConditions=yes&loc=en_US&tracknum=${trackingNumber}/trackdetails`;
    case 'purolator':
      return `https://www.purolator.com/en/shipping/tracker?pins=${trackingNumber}`;
    case 'dhl':
      return `http://www.dhl.com/content/g0/en/express/tracking.shtml?brand=DHL&AWB=${trackingNumber}`;
    case 'fedex':
      return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;
    case 'canada_post':
      return `http://www.canadapost.ca/cpotools/apps/track/personal/findByTrackNumber?trackingNumber=${trackingNumber}&LOCALE=en`;
    default:
      return null;
  }
}
